export const AB_API_HOSTS = {
	local_development: 'https://dev-api.aofl.com',
	development: 'https://dev-api.aofl.com',
	staging: 'https://dev-api.aofl.com',
	production: 'https://api.aofl.com'
};

export const DEVICE_KEY_MAP = {
	acquisition_source: 'acquisitionSource',
	device_id: 'deviceId',
	localeCode: 'localeCode',
	is_first_time_visit: 'isFirstTimeVisit',
	app_version: 'appVersion',
	country_code: 'viewerCountry',
	is_mobile_viewer: 'isMobileViewer',
	is_desktop_viewer: 'isDesktopViewer',
	is_webview: 'inApp',
	app_store: 'appStore',
	browser_platform: 'browserPlatform',
	// is_ios_viewer: 'isIosViewer',
	is_link_from_app: 'isLinkFromApp',
	is_aofl_product_uuid: 'isEmailLinkClick',
	is_link_from_email: 'isLinkFromEmail',
	is_automated_testing: 'isAutomatedTesting'
};

export const ACTIVE_EXPERIMENTS = {
	ABCM2_REBRAND_UPGRADE_OFFER: {
		experimentKey: 'annual-upgrade-price-point-offer-web',
		variants: {
			test: 'test',
			control: 'default'
		}
	},
	ABCM2_PERSONALIZED_CANCEL: {
		experimentKey: 'abcm2-personalized-cancel',
		variants: {
			test: 'Test',
			control: 'Control'
		}
	},
	ABCM2_ROKT: {
		experimentKey: 'rokt-2-vs-1',
		variants: {
			test: 'test',
			control: 'default'
		}
	},
	ABCM2_REACTIVATION_FLOW: {
		experimentKey: 'browser-reactivation-flow',
		variants: {
			test: 'test',
			control: 'default'
		}
	},
	ABCM2_GIVE_A_GIFT: {
		experimentKey: 'browser-nmhp-gift',
		variants: {
			test: 'test',
			control: 'default'
		}
	}
};

export const PROFILE = 'abcmouse';

export const EXPERIMENT_KEYS = [
	ACTIVE_EXPERIMENTS.ABCM2_PERSONALIZED_CANCEL.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_ROKT.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_REACTIVATION_FLOW.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_GIVE_A_GIFT.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_REBRAND_UPGRADE_OFFER.experimentKey
];

export const DATA_TYPES = {
	DEVICE: 'device',
	USER: 'user',
	SESSION: 'session',
	MASTER: 'master'
};

export const DATA_KEYS = {
	SUBSCRIPTION_STATUS: 'subscription_status',
	USER_SUBSCRIPTION_TYPE: 'user_subscription_type'
};
